// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5 1.5H11C12.1 1.5 13 2.4 13 3.5V12.5C13 13.6 12.1 14.5 11 14.5H5C3.9 14.5 3 13.6 3 12.5V3.5C3 2.4 3.9 1.5 5 1.5Z',
  'M5.5 4.5H10.5',
  'M5.5 7.2H5.51M8 7.2H8.01M10.5 7.2H10.51M5.5 9.6H5.51M8 9.6H8.01M5.5 12H5.51M8 12H8.01M10.5 9.6V12',
];
